module.exports = __webpack_public_path__ + "img/record.55fa349e.svg";